module.exports = __webpack_public_path__ + "static/media/back.71d1c389.png";